<script>
  'use strict'
  import { _tilesCollections, _tilesCollectionFileName } from "../store/store";

  let tileCollection = [];
  let tilesCollectionFileName = [];
  // -------------------------------------------------
  _tilesCollections.subscribe(data => {
    tileCollection = data;
    updateOnTilesChange();
  });

  _tilesCollectionFileName.subscribe(data => {
    tilesCollectionFileName = data;
  });

  // -------------------------------------------------
  function updateOnTilesChange() {
    document.documentElement.style.setProperty('--nb-tiles', tileCollection.length);
  }

  function onSelectFile(event) {
    Array.from(event.target.files).forEach((img, idx) => {
      const file = event.target.files[idx];
      var reader = new FileReader();
      reader.onload = function(e) {
        const imageFormatedInBase64 = e.target.result;
        _tilesCollections.set([...tileCollection, imageFormatedInBase64]);
        _tilesCollectionFileName.set([...tilesCollectionFileName, img.name]);
      };
      reader.readAsDataURL(file);
    })
  }
</script>

<div>
  <input type="file" name="importTiles" id="importTiles" on:change="{onSelectFile}" multiple tabindex=5 accept="image/*" hidden/>
  <label class="import-btn" for="importTiles">IMPORT TILES</label>
</div>
